import React, { memo } from "react";
import { Skeleton, TableCell, TableRow } from "@mui/material";

function LinhasSkeleton({ quantidade = 10 }) {
  return Array.from({ length: quantidade }).map((_, index) => (
    <TableRow key={`notas-fiscais-skeleton-${index}`}>
      <TableCell align="center">
        <Skeleton variant="circular" width={24} height={24} />
      </TableCell>
      <TableCell align="center">
        <Skeleton variant="text" width="70%" sx={{ mx: "auto" }} />
      </TableCell>
      <TableCell align="center">
        <Skeleton variant="text" width="70%" sx={{ mx: "auto" }} />
      </TableCell>
      <TableCell align="center">
        <Skeleton variant="text" width="70%" sx={{ mx: "auto" }} />
      </TableCell>
      <TableCell align="center">
        <Skeleton variant="text" width="70%" sx={{ mx: "auto" }} />
      </TableCell>
      <TableCell align="center">
        <Skeleton variant="text" width="70%" sx={{ mx: "auto" }} />
      </TableCell>
    </TableRow>
  ));
}

export default memo(LinhasSkeleton);
